<script lang="ts">
  import { parsePhoneNumberFromString } from "libphonenumber-js";
  import { onMount } from "svelte";

  let {
    phone = $bindable(),
    phoneInvalid,
    countryCodes,
    back,
  }: {
    phone: string;
    phoneInvalid: boolean;
    countryCodes: [string, string][];
    back: () => void;
  } = $props();

  let input = $state<HTMLInputElement>();

  const parsedPhone = phone && parsePhoneNumberFromString(phone);
  let country = $state(parsedPhone?.country || "GB");
  let national = $state(parsedPhone?.nationalNumber || "");

  const newParsed = $derived(country && national ? parsePhoneNumberFromString(national, { defaultCountry: country }) : null);

  function setValidity(message = ""): void {
    input.setCustomValidity(message);
  }

  function confirm(event): void {
    event.preventDefault();
    phone = newParsed.format("E.164");
    back();
  }

  onMount(()=>input.focus());

  $effect(()=>{
    if(!country) return setValidity();
    if(!national) return setValidity();

    if(!newParsed) return setValidity("Please enter a phone number");
    if(!newParsed.isValid()) return setValidity(`Must be a valid ${country} mobile number`);

    setValidity()
  })
</script>

<form onsubmit={confirm}>
  <h2 class="ui-title">Update Phone Number</h2>

  <div class="join w-full">
    <select
      class="join-item ui-select"
      autocomplete="tel-country-code"
      bind:value={country}
      required
    >
      {#each countryCodes as [label, value]}
        <option {value}>{label}</option>
      {/each}
    </select>

    <input
      type="tel"
      autocomplete="tel-national"
      class="join-item ui-input"
      class:border-error={phoneInvalid}
      bind:this={input}
      bind:value={national}
      placeholder="7123456789"
      required
    >
  </div>

  <div class="floating-footer">
    <button class="btn btn-ghost" type="button" onclick={back}>Back</button>
    <button class="btn btn-primary" type="submit">Continue</button>
  </div>
</form>
